import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  useScrollTrigger,
  makeStyles,
  AppBar,
  Avatar,
  IconButton,
  Typography,
  Toolbar,
  Menu,
  MenuItem,
  Link,
} from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import { Paths } from 'router/routes';
import { redirectToErp } from 'constants/auth';

const ElevationScroll = ({ children }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  title: {
    flexGrow: 1,
  },
}));

export default function AppToolbar({ onMenuClick, username }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const menuId = 'user-menu';

  const isMenuOpen = Boolean(anchorEl);
  const userInitial = username && username.substring(0, 1).toUpperCase();

  const handleUserMenuOpen = (event) => setAnchorEl(event.currentTarget);

  const handleLogOut = () => {
    redirectToErp();
  };

  const handleMenuClose = () => setAnchorEl(null);

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      id={menuId}
      keepMounted
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleLogOut}>Sair</MenuItem>
    </Menu>
  );

  return (
    <ElevationScroll>
      <>
        <AppBar className={classes.appBar} position="fixed">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open sidebar"
              onClick={onMenuClick}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              <Link href={Paths.DASHBOARD} color="inherit" underline="none">
                Sistema de Gestão de Documentação
              </Link>
            </Typography>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleUserMenuOpen}
              color="inherit"
            >
              <Avatar color="primary">{userInitial}</Avatar>
            </IconButton>
          </Toolbar>
        </AppBar>
        {renderMenu}
      </>
    </ElevationScroll>
  );
}

AppToolbar.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};
